"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.countryTaxonomyLoader = void 0;
var taxonomy_1 = require("src/taxonomy");
var CountryTaxonomyLoader = /** @class */ (function () {
    function CountryTaxonomyLoader() {
        this.alreadyProcessed = false;
    }
    CountryTaxonomyLoader.prototype.getTaxonomy = function (taxonomies) {
        var _this = this;
        // countriesTaxonomyPlaceholder coming from Umbraco Taxonomy API
        if (!this.countryService) {
            // tslint:disable-next-line:no-console
            console.warn('[CountryTaxonomyLoader] Trying to load countries taxonomy without country service');
            return Promise.resolve(null);
        }
        var countriesTaxonomy = taxonomy_1.TaxonomyService.getTaxonomyGroupByType(taxonomy_1.TaxonomyTypeEnum.CountriesTaxonomy, taxonomies);
        if (!countriesTaxonomy) {
            return Promise.resolve(null);
        }
        return this.countryService.getDataForSelectOptions().then(function (countries) {
            _this.alreadyProcessed = true;
            // state mutation!
            countriesTaxonomy.items = countries.map(function (country) {
                return {
                    filterValue: "".concat(countriesTaxonomy.filterValue, "=").concat(country.value),
                    items: null,
                    title: country.title,
                    value: country.value,
                };
            });
            countriesTaxonomy.updatedWithExternalMapper = true;
            return countriesTaxonomy;
        });
    };
    return CountryTaxonomyLoader;
}());
var countryTaxonomyLoader = new CountryTaxonomyLoader();
exports.countryTaxonomyLoader = countryTaxonomyLoader;
